import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBDgPwXj7h-Wq-0TIGDmKic0YWql_RoL8M",
  authDomain: "water-sy.firebaseapp.com",
  databaseURL: "https://water-sy-default-rtdb.firebaseio.com",
  projectId: "water-sy",
  storageBucket: "water-sy.appspot.com",
  messagingSenderId: "1022240950199",
  appId: "1:1022240950199:web:d2ba1c0d72788cd9c58a32",
};

// Initialize Firebase

const app = initializeApp(firebaseConfig);
const database = getDatabase(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { database, auth, storage };
export default app;
